import { render, staticRenderFns } from "./ThePersonalSkeletonOrder.vue?vue&type=template&id=32298ffe&"
import script from "./ThePersonalSkeletonOrder.vue?vue&type=script&lang=js&"
export * from "./ThePersonalSkeletonOrder.vue?vue&type=script&lang=js&"
import style0 from "./ThePersonalSkeletonOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports